import { render, staticRenderFns } from "./OfferTagsList.vue?vue&type=template&id=5c408886&scoped=true"
import script from "./OfferTagsList.vue?vue&type=script&lang=js"
export * from "./OfferTagsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c408886",
  null
  
)

export default component.exports